<template>
  <md-card
    class="payment-card"
    :class="mode === 'inPayment' ? ' payment-card-right' : ''"
  >
    <md-card-header
      class="md-card-header-icon"
      :class="
        mode === 'outPayment' ? 'md-card-header-danger' : 'md-card-header-green'
      "
    >
      <div class="card-icon">
        <md-icon>{{
          mode === 'outPayment' ? 'arrow_back' : 'arrow_forward'
        }}</md-icon>
      </div>

      <h4 class="title">{{ mode === 'outPayment' ? 'Isplata' : 'Uplata' }}</h4>
      <md-button
        class="md-just-icon md-round leave-button"
        @click="$emit('close', true)"
      >
        <md-icon> clear </md-icon>
      </md-button>
    </md-card-header>
    <md-card-content class="md-layout">
      <md-field v-if="setClient" class="md-layout-item">
        <label> Naziv klijenta </label>
        <p>
          {{ client.name }}
        </p>
      </md-field>
      <md-field v-else class="md-layout-item">
        <search-drop-down
          :title="'Klijent'"
          :items="clients"
          :defaultValue="client.name || ''"
          @updatedInput="searchClients"
          @selected="selectClient"
        />
      </md-field>
      <md-field class="md-layout-item">
        <label> Datum uplate </label>
        <md-datepicker v-model="payment.dateSigned" />
      </md-field>
      <md-field class="md-layout-item">
        <label> Iznos € </label>
        <md-input type="number" min="0" step="0.01" v-model="payment.amount">
        </md-input>
      </md-field>
      <md-field v-if="!cash" class="md-layout-item">
        <label>{{ mode === 'outPayment' ? 'Sa računa' : 'Na račun' }}</label>
        <md-select v-model="payment.bankAccountId">
          <md-option
            v-for="(option, index) in bankAccounts"
            :key="index"
            :value="option.id"
            >{{ option.name }}</md-option
          >
        </md-select>
      </md-field>
      <md-field v-else class="md-layout-item">
        <label>{{ mode === 'outPayment' ? 'Sa računa' : 'Na račun' }}</label>
        <p>Gotovina</p>
      </md-field>
      <md-field class="md-layout-item md-size-100">
        <label> Napomena </label>
        <md-textarea v-model="payment.comment"> </md-textarea>
      </md-field>
    </md-card-content>
    <md-card-actions md-alignment="right">
      <md-button class="md-success" @click="savePayment">
        <md-icon> save </md-icon>
        Sačuvaj
      </md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import services from '@/api/services';
import api from '@/api/api.js';
export default {
  props: {
    payment: {
      type: Object,
      default: () => ({
        bankAccountId: 1,
      }),
    },
    mode: String,
    client: {
      type: Object,
      default: () => ({}),
    },
    setClient: Boolean,
    cash: Boolean,
  },
  data() {
    return {
      bankAccounts: [],
      clients: [],
    };
  },
  methods: {
    searchClients(value) {
      api
        .get(services.getClient, {
          loadClient: true,
          clientName: value,
        })
        .then((data) => {
          this.clients = data;
        });
    },
    selectClient(value) {
      Object.assign(this.client, value);
    },
    getBankAccounts() {
      return api
        .get(services.getBankAccounts, { loadBankAccounts: true })
        .then((data) => {
          this.bankAccounts = data;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    savePayment() {
      const requestParams = Object.assign(this.payment, {
        mode: this.mode,
        clientId: this.client.id,
        direction: 'out',
        type: this.cash ? 'cash' : 'invoice',
      });

      if (this.cash)
        Object.assign(requestParams, {
          bankAccountId: 5,
        });

      return api
        .post(services.payments.setPayment, {
          setPayment: true,
          payment: JSON.stringify(requestParams),
        })
        .then((data) => {
          if (data.id) this.payment.id = data.id;
          this.$notify({
            timeout: 2500,
            message:
              'Ažurirana uplata ' + (this.payment.id ? this.payment.id : ''),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'success',
          });
          this.$emit('saved', false);
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
  },
  mounted() {
    this.getBankAccounts().then(() => {
      this.searchClients('');
    });
  },
};
</script>

<style scoped>
.md-card.payment-card {
  width: 100%;
  position: relative;
  left: 0%;
  transition: all 0.5s ease-in-out;
}

.md-card.payment-card.payment-card-right {
  left: 0px;
}
.leave-button {
  position: absolute;
  top: 0.7em;
  right: 0.7em;
}
</style>
